import { subscribe } from '@/utils'

import { Params, Response, Service } from '.'

const fetch = async (params: Params): Promise<Response> => {
	try {
		const res = await subscribe.get<Response>('account/address', { params })
		return res.data
	} catch (e) {
		throw e
	}
}

export const service: Service = {
	fetch
}
